import {createSlice, Dispatch} from '@reduxjs/toolkit';
import {AircraftDefinitionRequest} from 'app/types/service-types/AircraftTypes';
import {AircraftService} from 'app/services';
import {fetchAllAircrafts} from './aircrafts.slice';
import {errorMsg, successMsg} from 'app/utils/MessageUtils';

interface UpdateAircraftParams {
  id: string;
  body: AircraftDefinitionRequest;
  onSuccess?: Function;
  onError?: Function;
}

export const updateAircraft = (params: UpdateAircraftParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await AircraftService.update(params.id, params.body);
    if (response.status >= 200 && response.status < 300) {
      dispatch(setSuccess(true));
      dispatch(successMsg('Aircraft updated successfully!'));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(''));
      // @ts-ignore
      dispatch(fetchAllAircrafts());
    }
    dispatch(setLoading(false));
  } catch (err: any) {
    dispatch(setLoading(false));
    dispatch(errorMsg(err?.data?.message));
    if (params.onError) params.onError();
    dispatch(setError(err?.data?.message));
  }
}

export const regenerateSeats = (params: UpdateAircraftParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await AircraftService.regenerateSeats(params.id, params.body);
    if (response.status >= 200 && response.status < 300) {
      dispatch(setSuccess(true));
      dispatch(successMsg('Seats regenerated successfully!'));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(''));
      // @ts-ignore
      dispatch(fetchAllAircrafts());
    }
    dispatch(setLoading(false));
  } catch (err: any) {
    dispatch(setLoading(false));
    dispatch(errorMsg(err?.data?.message));
    if (params.onError) params.onError();
    dispatch(setError(err?.data?.message));
  }
}

interface UpdateAircraftSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: UpdateAircraftSlice = {
  error: '',
  success: false,
  loading: false
}

const stateSlice = createSlice({
  name: 'aircrafts/update-aircraft',
  initialState,
  reducers: {
    setLoading: (state, action) => { state.loading = action.payload },
    setSuccess: (state, action) => { state.success = action.payload },
    setError: (state, action) => { state.error = action.payload }
  }
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;
export default stateSlice.reducer;
